export default __webpack_public_path__ + "static/media/WheelWinsIcon.82329d8e.png";